import { merge, pick } from 'lodash';
import Bugsnag from '@bugsnag/js';
import { generateEmailMessage, generateEmailSubject } from './helpers';

export const defaultState = {
  // userInput
  userInput: {
    selectedElectorateId: undefined,
    selectedPartyId: undefined,
    selectedMPId: undefined,
    selectedTalkingPointsIds: [],
    firstName: '',
    lastName: '',
    email: '',
    postal_address: '',
    personalMessage: '',
    question_answer: null,
    message: undefined
  },
  // Submission state
  processingSendEmail: false,
  sendEmailComplete: false,
  sendEmailErrorMessage: ''
};

const createModel = (initialState = {}) => ({
  // Use defaultState and override with initialState is passed in
  // Use merge rather than spreading since 's recursive
  state: merge(defaultState, initialState),
  reducers: {
    setUserInput(state, updatedUserInput) {
      return {
        ...state,
        userInput: { ...state.userInput, ...updatedUserInput }
      };
    },
    generateAndSetEmailMessage(state) {
      return {
        ...state,
        userInput: {
          ...state.userInput,
          message: generateEmailMessage(state),
          subject: generateEmailSubject(state)
        }
      };
    },
    sendEmailRequest(state) {
      return {
        ...state,
        processingSendEmail: true,
        sendEmailComplete: false,
        sendEmailErrorMessage: ''
      };
    },
    sendEmailComplete(state) {
      return {
        ...state,
        sendEmailComplete: true,
        processingSendEmail: false
      };
    },
    sendEmailError(state, sendEmailErrorMessage) {
      return {
        ...state,
        processingSendEmail: false,
        sendEmailComplete: false,
        sendEmailErrorMessage
      };
    }
  },
  effects: (dispatch) => ({
    async sendEmail(_payload, rootState) {
      let payload;
      try {
        dispatch.mailToTarget.sendEmailRequest();

        const { userInput, aid, url, queryStringParameters } =
          rootState.mailToTarget;

        payload = {
          aid,
          first_name: userInput.firstName,
          last_name: userInput.lastName,
          email: userInput.email,
          postal_address: userInput.postal_address,
          mp: userInput.selectedMPId,
          subject: userInput.subject,
          message: userInput.message,
          question_answer: userInput.question_answer,
          party: userInput.selectedPartyId,
          electorate: userInput.selectedElectorateId,
          url,
          ...pick(
            queryStringParameters,
            'utm_source',
            'utm_medium',
            'utm_campaign',
            'utm_term',
            'utm_content'
          )
        };
        console.log(payload);

        const response = await fetch('/action/email', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.head.querySelector("[name='csrf-token']")
              .attributes['content'].value
          },
          credentials: 'same-origin',
          body: JSON.stringify(payload)
        });

        const responseJSON = await response.json();

        if (response.status === 200) {
          dispatch.mailToTarget.sendEmailComplete();
        } else if (response.status === 422) {
          const errorMessages = Object.values(responseJSON).join(', ');
          dispatch.mailToTarget.sendEmailError(errorMessages);
        } else {
          throw Error(responseJSON);
        }
      } catch (error) {
        // TODO - bugsnag
        Bugsnag.notify(error, (event) => {
          event.addMetadata('redux state', {
            ...pick(rootState.mailToTarget, 'aid', 'url', 'userInput')
          });
        });
        console.log(error);
        dispatch.mailToTarget.sendEmailError(
          'An error has occurred sending your email. If this problem continues, please email us at info@actionstation.org.nz'
        );
      }
    }
  })
});

export default createModel;
